import React from 'react';
import { Icon, Tooltip } from 'core/components';
import { DEFAULT_ICON_SIZE } from 'core/components/Icon';

// Device class icons
import { ReactComponent as IcmpIcon } from 'app/assets/recon/device-class/icmp.svg';
import { ReactComponent as FlowIcon } from 'app/assets/recon/device-class/flow.svg';
import { ReactComponent as FlowIcmpIcon } from 'app/assets/recon/device-class/flow-icmp.svg';
import { ReactComponent as RouterIcon } from 'app/assets/recon/device-class/router.svg';
import { ReactComponent as AccessPointIcon } from 'app/assets/recon/device-class/access-point.svg';
import { ReactComponent as ServerIcon } from 'app/assets/recon/device-class/server.svg';
import { ReactComponent as SwitchIcon } from 'app/assets/recon/device-class/switch.svg';
import { ReactComponent as FirewallIcon } from 'app/assets/recon/device-class/firewall.svg';
import { ReactComponent as PduIcon } from 'app/assets/recon/device-class/pdu.svg';
import { ReactComponent as UpsIcon } from 'app/assets/recon/device-class/ups.svg';
import { ReactComponent as LoadBalancerIcon } from 'app/assets/recon/device-class/load-balancer.svg';
import { ReactComponent as OpticalTransportIcon } from 'app/assets/recon/device-class/optical-transport.svg';
import { ReactComponent as SdwanGatewayIcon } from 'app/assets/recon/device-class/sdwan-gateway.svg';
import { ReactComponent as StorageArrayIcon } from 'app/assets/recon/device-class/storage-array.svg';
import { ReactComponent as WirelessControllerIcon } from 'app/assets/recon/device-class/wireless-controller.svg';
import { ReactComponent as SecurityApplianceIcon } from 'app/assets/recon/device-class/security-appliance.svg';
import { ReactComponent as IcmpFillIcon } from 'app/assets/recon/device-class/icmp-fill.svg';
import { ReactComponent as FlowFillIcon } from 'app/assets/recon/device-class/flow-fill.svg';
import { ReactComponent as FlowIcmpFillIcon } from 'app/assets/recon/device-class/flow-icmp-fill.svg';
import { ReactComponent as RouterFillIcon } from 'app/assets/recon/device-class/router-fill.svg';
import { ReactComponent as AccessPointFillIcon } from 'app/assets/recon/device-class/access-point-fill.svg';
import { ReactComponent as ServerFillIcon } from 'app/assets/recon/device-class/server-fill.svg';
import { ReactComponent as SwitchFillIcon } from 'app/assets/recon/device-class/switch-fill.svg';
import { ReactComponent as FirewallFillIcon } from 'app/assets/recon/device-class/firewall-fill.svg';
import { ReactComponent as PduFillIcon } from 'app/assets/recon/device-class/pdu-fill.svg';
import { ReactComponent as UpsFillIcon } from 'app/assets/recon/device-class/ups-fill.svg';
import { ReactComponent as LoadBalancerFillIcon } from 'app/assets/recon/device-class/load-balancer-fill.svg';
import { ReactComponent as OpticalTransportFillIcon } from 'app/assets/recon/device-class/optical-transport-fill.svg';
import { ReactComponent as SdwanGatewayFillIcon } from 'app/assets/recon/device-class/sdwan-gateway-fill.svg';
import { ReactComponent as StorageArrayFillIcon } from 'app/assets/recon/device-class/storage-array-fill.svg';
import { ReactComponent as WirelessControllerFillIcon } from 'app/assets/recon/device-class/wireless-controller-fill.svg';
import { ReactComponent as SecurityApplianceFillIcon } from 'app/assets/recon/device-class/security-appliance-fill.svg';
import { AllDeviceClass, AllDeviceClassLabel } from 'app/util/nms/deviceMetadata';

const classMap = {
  [AllDeviceClass.Router]: {
    icon: RouterIcon,
    fillIcon: RouterFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Router]
  },
  [AllDeviceClass.Switch]: {
    icon: SwitchIcon,
    fillIcon: SwitchFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Switch]
  },
  [AllDeviceClass.Firewall]: {
    icon: FirewallIcon,
    fillIcon: FirewallFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Firewall]
  },
  [AllDeviceClass.LoadBalancer]: {
    icon: LoadBalancerIcon,
    fillIcon: LoadBalancerFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.LoadBalancer]
  },
  [AllDeviceClass.SdwanGateway]: {
    icon: SdwanGatewayIcon,
    fillIcon: SdwanGatewayFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.SdwanGateway]
  },
  [AllDeviceClass.WirelessController]: {
    icon: WirelessControllerIcon,
    fillIcon: WirelessControllerFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.WirelessController]
  },
  [AllDeviceClass.AccessPoint]: {
    icon: AccessPointIcon,
    fillIcon: AccessPointFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.AccessPoint]
  },
  [AllDeviceClass.Server]: {
    icon: ServerIcon,
    fillIcon: ServerFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Server]
  },
  [AllDeviceClass.UPS]: { icon: UpsIcon, fillIcon: UpsFillIcon, description: AllDeviceClassLabel[AllDeviceClass.UPS] },
  [AllDeviceClass.PDU]: { icon: PduIcon, fillIcon: PduFillIcon, description: AllDeviceClassLabel[AllDeviceClass.PDU] },
  [AllDeviceClass.OpticalTransport]: {
    icon: OpticalTransportIcon,
    fillIcon: OpticalTransportFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.OpticalTransport]
  },
  [AllDeviceClass.StorageArray]: {
    icon: StorageArrayIcon,
    fillIcon: StorageArrayFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.StorageArray]
  },
  [AllDeviceClass.SecurityAppliance]: {
    icon: SecurityApplianceIcon,
    fillIcon: SecurityApplianceFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.SecurityAppliance]
  },
  [AllDeviceClass.Flow]: {
    icon: FlowIcon,
    fillIcon: FlowFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Flow]
  },
  [AllDeviceClass.FlowIcmp]: {
    icon: FlowIcmpIcon,
    fillIcon: FlowIcmpFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.FlowIcmp]
  },
  [AllDeviceClass.Icmp]: {
    icon: IcmpIcon,
    fillIcon: IcmpFillIcon,
    description: AllDeviceClassLabel[AllDeviceClass.Icmp]
  }
};

const DeviceIcon = ({ icon, ariaLabel, iconSize, primary, tooltip, ...props }) => {
  const IconComponent = (
    <Icon icon={icon} ariaLabel={ariaLabel} iconSize={iconSize} color={primary ? 'primary' : undefined} {...props} />
  );

  return tooltip ? (
    <Tooltip
      content={tooltip.content}
      position={tooltip.position}
      className="icon-wrapper-no-line-height"
      {...tooltip.tooltipProps}
    >
      {IconComponent}
    </Tooltip>
  ) : (
    IconComponent
  );
};

function DeviceClassIcon({
  iconStyle,
  deviceModel,
  showTooltip,
  tooltipPosition,
  tooltipProps,
  fill,
  primary,
  iconSize,
  // Use this prop to make sure this component always takes up the same amount of space, regardless of if it is showing an icon or not
  fillSpaceIfNull,
  ...props
}) {
  const realIconSize = iconSize || DEFAULT_ICON_SIZE;
  const Fallback = fillSpaceIfNull ? <div style={{ width: realIconSize, height: realIconSize }} /> : null;

  if (!deviceModel) {
    return Fallback;
  }

  const classification = deviceModel.deviceClass;

  if (!classification) {
    return Fallback;
  }
  const classInfo = classMap[classification];
  if (!classInfo) {
    return Fallback;
  }
  const icon = fill ? classInfo.fillIcon : classInfo.icon;
  if (!icon) {
    return Fallback;
  }
  const tooltip = showTooltip
    ? {
        content: classInfo.description,
        position: tooltipPosition,
        tooltipProps
      }
    : undefined;

  return (
    <DeviceIcon
      icon={icon}
      ariaLabel={classInfo.description}
      iconSize={iconSize}
      primary={primary}
      tooltip={tooltip}
      {...props}
    />
  );
}

export default DeviceClassIcon;
